import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navigation/Navbar';
import Home from './pages/Home';
import NewDream from './components/NewDream';
import DreamJournal from './components/DreamJournal/DreamJournal';
import Statistics from './components/Statistics';
import Profile from './components/Profile';
import AdminPage from './components/Admin/AdminPage';
import LoginModal from './components/LoginModal';
import { AuthProvider } from './contexts/AuthContext';
import { LoginModalProvider, useLoginModal } from './contexts/LoginModalContext';
import theme from './theme/theme';
import './styles/globals.css';
import { setupAdminUser } from './firebase/adminSetup';
import ProfilePage from './pages/ProfilePage';
import Blog from './components/Blog/Blog';
import Gallery from './pages/Gallery';
import Legal from './pages/Legal';
import FAQ from './pages/FAQ';
import Footer from './components/Footer';

// Exécuter une seule fois pour configurer l'admin
setupAdminUser();

function AppContent() {
  const { isOpen, closeLoginModal, openLoginModal } = useLoginModal();
  const location = window.location;
  
  // Envoyer une vue de page à chaque chargement de page
  React.useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location.pathname]);

  return (
    <div className="App">
      <Navbar onLoginClick={openLoginModal} />
      <LoginModal
        isOpen={isOpen}
        onClose={closeLoginModal}
      />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/new-dream" element={<NewDream />} />
        <Route path="/dream-journal" element={<DreamJournal />} />
        <Route path="/statistics" element={<Statistics />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/faq" element={<FAQ />} />
      </Routes>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <HelmetProvider>
        <AuthProvider>
          <LoginModalProvider>
            <Router>
              <AppContent />
            </Router>
          </LoginModalProvider>
        </AuthProvider>
      </HelmetProvider>
    </ThemeProvider>
  );
}

export default App;
